import * as colors from '@giphy/colors'
import { PureComponent } from 'react'
import { Title } from 'shared/components/text-elements'
import styled from 'styled-components'
import AppDetail from './app'
import AppButton from './app-button'

const AllApps = styled.div`
    background: ${colors.giphyDarkestGrey};
    padding: 50px 30px;
`

export default class AppsLanding extends PureComponent {
    static defaultProps = {
        currentApp: null,
        apps: [],
    }
    render() {
        const { currentApp, apps } = this.props
        const isAppDetail = !!currentApp
        const showApps = isAppDetail ? [currentApp] : apps
        return (
            <div>
                {showApps.map((app, i) => (
                    <AppDetail {...app} key={app.slug} index={i} isDetail={isAppDetail} />
                ))}
                {isAppDetail && (
                    <AllApps>
                        <Title>All Our Apps</Title>
                        {apps.map((app) => (
                            <AppButton {...app} key={app.slug} />
                        ))}
                    </AllApps>
                )}
            </div>
        )
    }
}
